<div class="row pt-3">
  <div class="col">
    <form [formGroup]="searchForm" class="row">
      <div class="input-group mb-3">
        <input type="text" name="search" formControlName="search" class="form-control no-outline"
          placeholder="{{ 'search' | label: 'learningpath' | async }}" />
      </div>
    </form>
    <div *ngIf="notSubscribed.length" cdkDropList #unsubscribedList="cdkDropList" [cdkDropListData]="notSubscribed"
      [cdkDropListConnectedTo]="[dropArea]" class="list-group scroll-container" infiniteScroll
      [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100" (scrolled)="onScrollNotSubscribed()"
      [scrollWindow]="false">
      <div [cdkDragData]="student" cdkDrag *ngFor="let student of notSubscribed"
        class="list-group-item list-group-item-action">
        {{ student.firstName }} {{ student.lastName }}
      </div>
    </div>
  </div>
  <div class="col p-4">
    <div cdkDropList (cdkDropListDropped)="endDrag($event)" #dropArea="cdkDropList"
      class="drop-target rounded dropAreaZone" style="min-height: 500px; text-align: center">
      <div class="beforeDrop">
        <i class="far fa-plus-square" style="vertical-align: middle; font-size: 5em"></i>
        <p>
          <!--Sleep medewerkers naar hier om ze in te schrijven.-->
          {{ 'dragAndDropToRegister' | label: 'learningpath' | async }}
        </p>
      </div>
    </div>
  </div>
  <div class="col">
    <p class="mb-1 pb-3" style="font-weight: bold">
      <!--Ingeschreven medewerkers-->
      {{ 'registered_Employees' | label: 'learningpath' | async }}
      <i class="fas fa-sync-alt ms-2 cursor-pointer" (click)="reloadSubscribed()"></i>
    </p>
    <div *ngIf="subscribed.length" class="list-group scroll-container" infiniteScroll [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="100" (scrolled)="onScrollSubscribed()" [scrollWindow]="false">
      <div *ngFor="let student of subscribed" class="list-group-item list-group-item-action cursor-pointer"
        [routerLink]="[
          '/lms/learnpaths/external',
          learningPathId,
          'employee',
          'detail',
          student.learningPathStudentId
        ]">
        {{ student.firstName }} {{ student.lastName }}
      </div>
    </div>
  </div>
</div>